// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5106c0c6","453":"4800f054","455":"c8dc2502","977":"79e2d1e2"}[chunkId] + ".chunk.js";
};